import { LAYOUT_TYPE } from '../constants/common.constant';
import { SORT_ORDER } from '../constants/filter.constant';
import { REPORT_STATUS } from '../constants/report.constant';
import {
  DefaultResponse,
  InstitutionProp,
  Order,
  Procedure,
  UserDetailResponse,
  User,
  VisitedPatient,
} from '../interfaces/index';
import api from '../api';
import { AxiosResponse } from 'axios';
import { ACCESS_TYPE } from './share.api';

const REPORT_URL = '/reports/v1';

interface ParamsGetReports {
  his_synced?: boolean;
  institution_ids?: string[];
  is_printed?: boolean;
  limit?: number;
  offset?: number;
  order_id?: string;
  report_date_from?: string;
  report_date_to?: string;
  sort_field?: '' | 'user_id' | 'created_at' | 'updated_at' | 'institution_id';
  sort_order?: SORT_ORDER;
  status?: REPORT_STATUS;
  user_ids?: string[];
}
export interface ResponseGetReports extends DefaultResponse {
  data: {
    approved_at: Date;
    approver: ResponseApprover['data'] | null;
    approver_id: string;
    conclusion: string;
    content: string;
    created_at: Date;
    film_quantity: number;
    film_type: number;
    id: string;
    institution: InstitutionProp;
    institution_id: string;
    is_printed: boolean;
    layout: null | {
      content: string;
      name: string;
      status: LAYOUT_TYPE;
    };
    layout_id: null | string;
    metadata: null | {
      is_submitted: boolean;
    };
    order: Order;
    order_id: string;
    procedure: Procedure & {
      active: boolean;
      created_at: Date;
      id: string;
      institution: null;
      institution_id: string;
      procedure_group: null;
      updated_at: Date;
      user: null | unknown;
      user_id: string;
    };
    procedure_id: string;
    session: string;
    share_access_keys: {
      key: string;
      type: ACCESS_TYPE;
      password: string;
      study_instance_uid: string;
      visit_id: string;
    }[];
    status: REPORT_STATUS;
    submitted_at: Date;
    submitter: UserDetailResponse | null;
    submitter_id: string;
    technician: UserDetailResponse | null;
    technician_id: string;
    updated_at: Date;
    user: UserDetailResponse;
    user_id: string;
    visited_patient: VisitedPatient;
  }[];
}
export const getReports = async (
  params: ParamsGetReports = {
    limit: 100,
    offset: 0,
  }
) => {
  const response = (await api({
    url: REPORT_URL,
    method: 'GET',
    params,
    timeout: 30_000,
  })) as AxiosResponse<ResponseGetReports>;

  return response.data;
};

export interface ResponseApprover extends DefaultResponse {
  data: {
    address: string;
    birthdate: string;
    created_at: string;
    creator_id: string;
    email: string;
    expired_at: string;
    fullname: string;
    gender: number;
    his_id: string;
    id: string;
    institutions: string[];
    is_super: boolean;
    phone: string;
    roles: string[];
    scopes: string[];
    signature: string;
    status: number;
    title: string;
    updated_at: string;
    username: string;
  };
}

export const getApprover = async (params: { id: string }) => {
  const { id } = params;

  if (!id) return null;

  const response = (await api({
    url: `${REPORT_URL}/approver/${id}`,
    method: 'GET',
    timeout: 30_000,
  })) as AxiosResponse<ResponseApprover>;

  return response.data;
};

export interface ParamsCreateReport {
  institution_id: string;
  order_assign_id?: string;
  order_id: string;
}
export const createReport = async (data: ParamsCreateReport) => {
  const response = (await api({
    url: REPORT_URL,
    method: 'POST',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export interface ParamsUpdateApproveReport {
  conclusion: string;
  content: string;
  layout_id: string;
  order_assign_id?: string;
  technician_id: string;
}
export const updateApproveReport = async (
  id: string,
  data: ParamsUpdateApproveReport
) => {
  const response = (await api({
    url: `${REPORT_URL}/approve/${id}`,
    method: 'PUT',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export interface ParamsUpdateEditReport {
  order_assign_id?: string;
}
export const updateEditReport = async (
  id: string,
  data: ParamsUpdateCancelReport = {}
) => {
  const response = (await api({
    url: `${REPORT_URL}/edit/${id}`,
    method: 'PUT',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export interface ParamsUpdateSubmitReport {
  conclusion: string;
  content: string;
  film_quantity: number;
  film_type: number;
  layout_id: string;
  // order_assign_id?: string;
  technician_id: string;
}
export const updateSubmitReport = async (
  id: string,
  data: ParamsUpdateSubmitReport
) => {
  const response = (await api({
    url: `${REPORT_URL}/submit/${id}`,
    method: 'PUT',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export interface ParamsUpdateCancelReport {
  order_assign_id?: string;
}
export const updateCancelReport = async (
  id: string,
  data?: ParamsUpdateCancelReport = {}
) => {
  const response = (await api({
    url: `${REPORT_URL}/cancel/${id}`,
    method: 'PUT',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};
